exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-strapi-resumya-category-slug-js": () => import("./../../../src/pages/{strapiResumyaCategory.slug}.js" /* webpackChunkName: "component---src-pages-strapi-resumya-category-slug-js" */),
  "component---src-pages-strapi-resumya-post-slug-js": () => import("./../../../src/pages/{strapiResumyaPost.slug}.js" /* webpackChunkName: "component---src-pages-strapi-resumya-post-slug-js" */)
}

